import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { EditorCard } from './editor-card';

import './editors-section.scss';

export function EditorsSection({ editorsSection = DEFAULT_CONTENT, withTitle = true, withBorder = true }) {
  const { title } = editorsSection;
  const editors = editorsSection.children();

  return (
    <section className="editors-section mb-2">
      {withTitle && <h2 className="heading-3 mb-1">{title}</h2>}
      <Row className={classnames('editors-list', { 'border px-1 py-0_75 rounded': withBorder })}>
        {editors.map(editor => (
          <Col xs={12} md={6} key={editor.id} className="my-0_75">
            <EditorCard editor={editor} />
          </Col>
        ))}
      </Row>
    </section>
  );
}

EditorsSection.propTypes = {
  editorsSection: CmsEntities.Content,
  withTitle: PropTypes.bool,
  withBorder: PropTypes.bool,
};
